// extracted by mini-css-extract-plugin
export default {"wrapper":"Ed","form":"Fd","smallprint":"Gd","asterisk":"Hd","success":"Id","circle":"Jd","button":"Kd"};